import React, { useMemo, useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Loader2, Send, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import { contentCalendarAPI } from '../lib/api';

export default function AssignChangesPanel({ post, team = [], onAssigned }) {
  const members = useMemo(() => team.filter((m) => ['ceo', 'manager', 'member'].includes(m.role) && m.is_active !== false), [team]);
  const [userId, setUserId] = useState('');
  const [nota, setNota] = useState('');
  const [busy, setBusy] = useState(false);
  const lastClient = [...(post.observaciones || [])].reverse().find((o) => o.autor_tipo === 'cliente');
  const assigned = members.find((m) => m.id === post.cambios_asignados_a);

  const send = async () => {
    if (!userId) return;
    setBusy(true);
    try {
      const r = await contentCalendarAPI.assignChanges(post.id, userId, nota);
      toast.success(`Cambios enviados a ${r.assigned_name} · tiene su tarea`);
      setNota(''); setUserId('');
      onAssigned?.(r.assigned_to);
    } catch (e) { toast.error(e?.message || 'No se pudo reasignar'); }
    finally { setBusy(false); }
  };

  return (
    <Card className="border-orange-300 bg-orange-50/60" data-testid="assign-changes-panel">
      <CardContent className="p-4 space-y-3">
        <p className="text-sm font-semibold flex items-center gap-2 text-orange-800"><AlertTriangle className="w-4 h-4" /> El cliente ha solicitado cambios</p>
        {lastClient && <p className="text-sm whitespace-pre-wrap bg-white rounded-md border border-orange-200 p-2" data-testid="assign-changes-last-obs">«{lastClient.texto}»</p>}
        {assigned && <p className="text-xs text-orange-800" data-testid="assign-changes-current">Enviado a <b>{assigned.name}</b>. Puedes reenviarlo a otra persona.</p>}
        <div className="flex gap-2">
          <Select value={userId} onValueChange={setUserId}>
            <SelectTrigger className="bg-white" data-testid="assign-changes-select"><SelectValue placeholder="Enviar los cambios a…" /></SelectTrigger>
            <SelectContent>
              {members.map((m) => <SelectItem key={m.id} value={m.id} data-testid={`assign-changes-option-${m.id}`}>{m.name}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button onClick={send} disabled={!userId || busy} className="bg-orange-600 hover:bg-orange-700 text-white shrink-0" data-testid="assign-changes-send">
            {busy ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Send className="w-4 h-4 mr-1.5" />} Enviar
          </Button>
        </div>
        <Textarea rows={2} value={nota} onChange={(e) => setNota(e.target.value)} placeholder="Indicaciones opcionales para quien lo corrija…" className="bg-white text-sm resize-none" data-testid="assign-changes-nota" />
        <p className="text-[11px] text-muted-foreground">Recibirá una tarea con las observaciones del cliente. Si lo corriges tú, no hace falta enviarlo.</p>
      </CardContent>
    </Card>
  );
}
